import React from 'react';
import { Button } from '@mui/material';
import moment from 'moment';

export const tankFormConfig = {
    form: {
        tank_number: {
            name: 'tank_number',
            Component: 'FormInput',
            props: {
                variant: 'outlined',
                label: 'Tank Number',
                required: true,
            },
            widths: { sm: 12 },
        },
        tank_capacity: {
            name: 'tank_capacity',
            Component: 'FormInput',
            props: {
                variant: 'outlined',
                label: 'Tank Capacity (L)',
                valueAsNumber: true,
                type: 'number',
                required: true,
            },
            widths: { sm: 12 },
        },
        calibration_date: {
            name: 'calibration_date',
            Component: 'DatePicker',
            props: {
                variant: 'outlined',
                label: 'Calibration Date',
                ignoreLockPeriod: true,
                required: true,
            },
            widths: { sm: 12 },
        },
    },
    form_layout: [
        {
            Component: 'Section',
            fields: ['tank_number', 'tank_capacity', 'calibration_date'],
        },
    ],
    validation: {
        type: 'object',
        properties: {
            tank_capacity: {
                type: 'number',
                min: 0,
            },
        },
    },
    validation_config: {
        errMessages: {
            tank_capacity: {
                min: 'Tank capacity must be greater than zero',
            },
        },
    },
};

export const getErrorMessage = (action, subject) => {
    return `There was a problem ${action} your ${subject}. Please contact support if this issue persists.`;
};

export const getIndexByTankNumber = (tankNumber, tanks) => tanks?.findIndex?.((t) => t?.tank_number === tankNumber) ?? -1;

export const getTableColumns = (tanks, bulkCharts, handleDownloadBulkChart, handleDeleteBulkChart) => [
    { field: 'tank_number', headerName: 'Tank #', flex: 1 },
    { field: 'tank_capacity', headerName: 'Capacity (L)', valueGetter: ({ value }) => value || 'N/A', flex: 1 },
    { field: 'calibration_date', headerName: 'Calibration Date', valueGetter: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : 'N/A'), flex: 1 },
    {
        field: 'download_bulk_chart_action',
        headerName: 'Bulk Charts',
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        flex: 1,
        renderCell: (params) => {
            const idx = getIndexByTankNumber(params?.row?.tank_number, tanks);
            if (bulkCharts?.[idx] === '') {
                return <></>;
            }
            return (
                <Button
                    variant="text"
                    sx={{ fontSize: '14px', fontWeight: 600, textTransform: 'none' }}
                    onClick={() => handleDownloadBulkChart(idx)} // wrap
                >
                    Download
                </Button>
            );
        },
    },
    {
        field: 'delete_bulk_chart_action',
        headerName: '',
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        flex: 1,
        renderCell: (params) => {
            const idx = getIndexByTankNumber(params?.row?.tank_number, tanks);
            if (bulkCharts?.[idx] === '') {
                return <></>;
            }
            return (
                <Button
                    variant="text"
                    color="error"
                    sx={{ fontSize: '14px', fontWeight: 600, textTransform: 'none' }}
                    onClick={() => handleDeleteBulkChart(idx)} // wrap
                >
                    Delete
                </Button>
            );
        },
    },
];
